import { useState } from 'react';
import KpiListService from './KpiListService';

function useManageKpiLists() {
    const [kpiLists, setKpiLists] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const refreshKpiLists = async () => {
        setIsLoading(true);
        try {
            const response = await KpiListService.getKpiLists();
            setKpiLists(response.data);
            setError(null);
        } catch (err) {
            console.log(err);
            setError(err);
        } finally {
            setIsLoading(false);
        }
    };

    const addKpiList = async (kpiListData) => {
        let result = true;
        setIsLoading(true);
        try {
            await KpiListService.addKpiList(kpiListData);
            refreshKpiLists();
        } catch (err) {
            result = false;
            setError(err.response?.data?.message || 'An error occurred.');
        } finally {
            setIsLoading(false);
        }
        return result;
    };

    const editKpiList = async (kpiListId, updatedData) => {
        setIsLoading(true);
        try {
            await KpiListService.editKpiList(kpiListId, updatedData);
            refreshKpiLists();
        } catch (err) {
            setError(err);
        } finally {
            setIsLoading(false);
        }
    };

    const deleteKpiList = async (kpiListId) => {
        setIsLoading(true);
        try {
            await KpiListService.deleteKpiList(kpiListId);
            refreshKpiLists();
        } catch (err) {
            setError(err);
        } finally {
            setIsLoading(false);
        }
    };

    return {
        kpiLists,
        isLoading,
        error,
        addKpiList,
        editKpiList,
        deleteKpiList,
        refreshKpiLists
    };
}

export default useManageKpiLists;

